<template lang="pug">
    article
      v-row()
        v-col(cols="12" md="6")
          v-responsive(v-if="!error && isProcessed" :aspect-ratio="16/9")
            v-card.rounded-lg.card.elevation-25.videoCover
              v-img.primary.flex-grow-0(cover @click.prevent="displayMovie(video)" :aspect-ratio="16/9" :src='getThumbnailUrl(video.id, video.token, video.element)' )
                template(v-slot:default)
                  v-row.play-overlay.fill-height.ma-0(align='center' justify='center')
                    v-icon.white--text fas fa-play
          v-responsive(v-if="error || video.status == VideoStatus.FAILED" :aspect-ratio="16/9")
            v-card.rounded-lg.card.elevation-25.flex-grow-0(color="primary" min-height="220")
              v-row.process-overlay.fill-height.ma-0(align='center' justify='center')
                .err.text-center.py-12
                  v-icon.white--text fas fa-exclamation-circle
          v-responsive(:aspect-ratio="16/9" v-if="video.status == VideoStatus.PROCESSING || video.status == VideoStatus.PENDING")
            v-card.rounded-lg.card.elevation-25.flex-grow-0(color="primary"   min-height="220")
              v-row.process-overlay.fill-height.ma-0(align='center' justify='center')
                .err.text-center.py-12
                  //- v-progress-circular(:size="50" color="white" indeterminate)
                  v-progress-circular(indeterminate :width="1" :size="20" color="white")
                  h3.mt-4.white--text {{$t("motions.inProgress")}}
        v-col(cols="12" md="6")
          v-card.rounded-lg.card.elevation-25
            v-card-text.mt-2.ml-2
              router-link(:to="{name: video.element == VideoElement.CLIP ? 'clip':'motion', params: {videoId: video.id }}")
                v-card-title.px-0.py-0.primary--text {{video.title}}
              span.caption.blue-grey--text.lighten-3 {{formatDate(video.createdAt)}}
              div 
                v-chip.mt-4.mr-2(label small color="accent" v-for="(category, index) in video.categories.items" :key="index") {{ category.category.title }}                
              v-card-subtitle.blue-grey--text.lighten-1.px-0(v-html="video.description")
            .bottomItems.mt-auto.px-3
              VideoMotionCardActions(:video="video")
              
      v-divider.mt-6
</template>
<script>
import date from "@/utils/date";
import urlFormat from "@/utils/urlFormat";
import { VideoStatus, VideoElement } from "../../models";
import VideoStatusIcons from "./VideoStatusIcons";
import VideoMotionCardActions from "./VideoMotionCardActions";
import VueVideoPlayer from "vue-video-player";
export default {
  name: "Card",
  components: {
    VideoStatusIcons,
    VideoMotionCardActions,
  },
  props: ["video"],
  data() {
    const source = VueVideoPlayer.videojs.browser.IS_ANY_SAFARI
      ? {
          src: this.getVideoDownloadUrl(
            this.video.id,
            this.video.token,
            "_16x9_1920x1080p_24Hz_6Mbps",
            "mp4"
          ),

          type: "video/mp4",
        }
      : {
          src: this.getVideoStreamUrl(this.video.id, this.video.token),
          type: "application/x-mpegURL",
        };

    return {
      VideoStatus,
      VideoElement,
      error: false,
      playerOptions: {
        fluid: true,
        autoplay: false,
        loop: false,
        controls: true,
        language: "de",

        poster: this.getThumbnailUrl(
          this.video.id,
          this.video.token,
          this.video.element
        ),
        sources: [source],
      },
      html5: {
        nativeAudioTracks: false,
        nativeVideoTracks: false,
        hls: {
          overrideNative: true,
        },
      },
      hls: {
        overrideNative: true,
      },
    };
  },
  computed: {
    isProcessed() {
      return this.video.status == VideoStatus.COMPLETED;
    },
  },

  methods: {
    ...date,
    ...urlFormat,
    playerReadied(player) {
      const token = this.video.token;
      player.tech_.hls.xhr.beforeRequest = function (options) {
        options.uri = `${options.uri}${token}`;
        return options;
      };
    },
    displayMovie(item) {
      this.$store.commit("player/set_video_dialog", {
        visible: true,
        element: item.element,
        src: this.getVideoStreamUrl(item.id, item.token),
        token: item.token,
        srcMP4: this.getVideoDownloadUrl(
          item.id,
          item.token,
          "_16x9_1920x1080p_24Hz_6Mbps",
          "mp4"
        ),
      });
    },
  },
};
</script>
<style lang="sass" scoped>
@import '@/assets/style/main'

.videoCover
  cursor: pointer
  .play-overlay
    background: rgba(0,0,0,0.2)
    transition: all 0.3s ease
    cursor: pointer
    opacity: 0
    &:hover
      opacity: 1
  &:hover
    .play-overlay
      transition: all 0.3s ease
      // background: rgba(0,0,0,0.2)
    .v-icon
      transform: scale(1.5)


.process-overlay
  background: rgba(0,0,0,0.2)
</style>
